import type { MealPlanRequestsAction, MealPlanRequestsState } from './types'
import { MealPlanRequestsActionTypes } from './types'

export const initialMealPlanRequestsState: MealPlanRequestsState = {
  mealPlanRequests: [],
  loading: true,
  error: null
}

export function mealPlanRequestsReducer(state: MealPlanRequestsState, action: MealPlanRequestsAction): MealPlanRequestsState {
  switch (action.type) {
    case MealPlanRequestsActionTypes.SET:
      return {
        ...state,
        mealPlanRequests: action.payload,
        loading: false,
        error: null
      }
    case MealPlanRequestsActionTypes.SET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case MealPlanRequestsActionTypes.CLEAR:
      return { ...initialMealPlanRequestsState }
    default:
      return state
  }
}
